import React from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
  name?: string;
  id?: string;
}

const FieldError: React.FC<Props> = ({ className, children, id, name }) => (
  <div
    className={classNames('mt-1 mb-4 text-xs text-red-500', className)}
    id={`${id || name}-error`}
  >
    {children}
  </div>
);

export default FieldError;
